import { usePopup } from "hooks/usePopup";
import { useSoundPath } from "hooks/useSoundPath";
import { Link, useLocation } from "react-router-dom";

const ActiveItemSellButton = () => {

  const {pathname} = useLocation();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const sellButtonHandler = () => {
    setPopupHook({type: 'sell'})
    playSound('main');
  }

  return (
    <>
    <button className="card-details__button" onClick={sellButtonHandler}>Sell</button>
    {
      !pathname.includes('marketplace') && <p className="card-details__button-hint">You can list several cards for sale from <Link to='/marketplace/cards?status=owned,not_sale'>marketplace page</Link> </p>
    }
    </>
  )
}

export default ActiveItemSellButton
